import * as React from 'react';
import * as s from './backdrop.scss';

export const TOUR_BACKDROP_WRAPPER_ID = 'tour-backdrop-wrapper';
export const DEFAULT_BACKDROP_OPACITY = 0.7;

export interface TourBackdropWrapperProps {
  show: boolean;
  opacity?: number;
  customStyle?: { [key: string]: string | number };
}

export class TourBackdropWrapper extends React.Component<
  TourBackdropWrapperProps
> {
  get opacity() {
    return this.props.opacity !== undefined
      ? this.props.opacity
      : DEFAULT_BACKDROP_OPACITY;
  }

  get customStyle() {
    return this.props.customStyle || {};
  }

  render() {
    return (
      <div id={TOUR_BACKDROP_WRAPPER_ID}>
        {this.props.show && (
          <div
            className={s.TourBackdropWrapper}
            style={{ opacity: this.opacity, ...this.customStyle }}
            data-hook="tour-backdrop"
          />
        )}
      </div>
    );
  }
}
